module.exports = __webpack_public_path__ + "static/media/blog-8.ce3d4dec.svg";